import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from './../auth/auth.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {
  hello = true;
  chekuser: any;
  emailid: any;
  userEmail;
  userNameEmail;
  rootDomainUrl;

  sign = 'visibility_off';
  professions = [
    { value: 'Civil engineer', viewValue: 'Civil engineer' },
    { value: 'Architect', viewValue: 'Architect' },
    { value: 'Engineer', viewValue: 'Engineer' },
  ];
  constructor(
    private authService: AuthService,
    private router: Router,
    public snackBar: MatSnackBar,
    private http: HttpClient
  ) {}
  registerForm: FormGroup;
  regFormData: any;
  ngOnInit() {
    this.rootDomainUrl = this.authService.rootDomainUrl;

    this.registerForm = new FormGroup({
      client: new FormControl('', Validators.required),
      profession: new FormControl('', Validators.required),

      pass: new FormControl('', Validators.required),
      emailid: new FormControl('', [
        Validators.required,
        Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$'),
      ]),

      mobile: new FormControl('', Validators.required),
    });
  }

  emaiToRegUser() {
    const bodyparm = new HttpParams()
      .set('user_name', this.userNameEmail)
      .set('email', this.userEmail);
    this.http
      .post(this.rootDomainUrl + 'adeos/api/email_newuser.php', bodyparm)
      .subscribe((data) => {
        if (data) {
        }
      });
  }

  onSubmitUser() {
    if (this.registerForm.valid) {
      const registrationSubscription = this.authService.registerUser(
        this.registerForm.value
      );
      if (registrationSubscription) {
        registrationSubscription.subscribe((data: any) => {
          this.emaiToRegUser();

          this.snackBar.open('Registration Sucess', 'clear', {
            duration: 5000,
          });
          this.regFormData = data;
          this.registerForm.reset();
          this.router.navigate(['/']);
        });
      }
    }
  }
  showPassword(input: any): any {
    input.type = input.type === 'password' ? 'text' : 'password';
    if (this.sign == 'visibility_off') {
      this.sign = 'visibility';
    } else {
      this.sign = 'visibility_off';
    }
  }
}
